export const SUPPORT_API_BASE_URL = '/support-api';
export const AUTH_API_BASE_URL = '/auth-api';
